import { Button } from "@components/ui/button"
import { Mail, Loader2 } from "lucide-react"
import { useSendMailCorrespondence } from "@apis/correspondences/useCorrespondences"
import { toast } from "sonner"
import { AxiosError } from "axios"
import { useCorrespondenceResolver } from "./utils/useCorrespondenceResolver"

interface TButtonProps {
  account_correspondence_id: number
  account_id: string
  isWelcome: boolean
}

export const SendMailButton = ({
  account_correspondence_id,
  account_id,
  isWelcome,
}: TButtonProps) => {
  const { getCorrespondenceId, isCorrespondenceResolverFetching } =
    useCorrespondenceResolver({
      account_id,
      account_correspondence_id,
      isWelcome,
    })
  const sendMailCorrespondenceMutation = useSendMailCorrespondence()

  const handleClick = async () => {
    const correspondenceId = await getCorrespondenceId()
    if (!correspondenceId) {
      toast.error("Error fetching welcome letter!")
      return
    }

    sendMailCorrespondenceMutation.mutate(
      {
        account_correspondence_id: correspondenceId,
      },
      {
        onSuccess: () => {
          toast.success("Mail successfully Sent!")
        },
        onError: (error: string | AxiosError) =>
          toast.error(`Error sending mail! ${error}`),
      },
    )
  }

  return (
    <Button
      size="icon"
      variant="ghost"
      onClick={handleClick}
      disabled={
        (!account_correspondence_id && !isWelcome) ||
        sendMailCorrespondenceMutation.isPending ||
        isCorrespondenceResolverFetching
      }
    >
      {sendMailCorrespondenceMutation.isPending ? (
        <Loader2 className="tw:animate-spin" />
      ) : (
        <Mail />
      )}
    </Button>
  )
}
